import { c as _c } from "react/compiler-runtime";
import { ErrorMessage, Icon } from "@justhome/react-ui";
import clsx from "clsx";
import de from "date-fns/locale/de";
import { ComponentProps, FC, forwardRef } from "react";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import styles from "./DatePicker.module.css";
registerLocale("de", de);
setDefaultLocale("de");
export interface DatePickerProps extends Pick<ComponentProps<typeof DatePicker>, "onBlur" | "maxDate"> {
  onChange: (date: Date | null) => void;
  value?: Date;
  label?: string;
  errorMessage?: string;
  placeholder?: string;
}
const CustomDatePicker: FC<DatePickerProps> = forwardRef<HTMLInputElement, DatePickerProps>((t0, ref) => {
  const $ = _c(20);
  const {
    label,
    maxDate,
    onChange,
    onBlur,
    value,
    errorMessage,
    placeholder
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <label className="text-title-1 flex mb-xs">{label}</label>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ref) {
    t2 = <input ref={ref} inputMode="none" className="relative" />;
    $[2] = ref;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = clsx("bg-neutral-0 shadow-3 border border-neutral-25 rounded-s overflow-hidden  p-s", styles.calendar);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon type="Left" size="20" className="p-3xs text-primary-800" />;
    t5 = <Icon type="Right" size="20" className="p-3xs text-primary-800" />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== maxDate || $[8] !== onBlur || $[9] !== onChange || $[10] !== placeholder || $[11] !== t2 || $[12] !== value) {
    t6 = <DatePicker placeholderText={placeholder} onBlur={onBlur} customInput={t2} className="text-button-1 m:text-body-2 rounded-s border transition-colors ease-out flex items-center text-inherit px-s py-[11px] border-neutral-50 text-neutral-575 hover:border-neutral-100 focus:border-neutral-100 placeholder:text-neutral-150 focus-visible:outline-none w-full" calendarClassName={t3} popperClassName="z-50 py-2xs" showPopperArrow={false} previousMonthButtonLabel={t4} nextMonthButtonLabel={t5} wrapperClassName="relative" selected={value} onChange={onChange} dateFormat="dd.MM.yyyy" maxDate={maxDate} peekNextMonth={true} showMonthDropdown={true} showYearDropdown={true} dropdownMode="select" />;
    $[7] = maxDate;
    $[8] = onBlur;
    $[9] = onChange;
    $[10] = placeholder;
    $[11] = t2;
    $[12] = value;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== errorMessage) {
    t7 = errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>;
    $[14] = errorMessage;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t1 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div>{t1}{t6}{t7}</div>;
    $[16] = t1;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
});
CustomDatePicker.displayName = "CustomDatePicker";
export default CustomDatePicker;